import { render, staticRenderFns } from "./AssetsColumnHeaders.vue?vue&type=template&id=567e57fc&scoped=true"
import script from "./AssetsColumnHeaders.vue?vue&type=script&lang=js"
export * from "./AssetsColumnHeaders.vue?vue&type=script&lang=js"
import style0 from "./AssetsColumnHeaders.vue?vue&type=style&index=0&id=567e57fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e57fc",
  null
  
)

export default component.exports